export const LOADING_MESSAGE = 'Loading custom hero...';
